import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'search-graph-customer-contact.customer-contact-label',
		defaultMessage: 'Customer Contact',
		description: 'Customer Contact subtype label',
	},
});
